export const getFormValidations = (
  tenantInfoValidations: any[],
  alternateValidation: any[],
  otherValidation: any[]
) => {
  return [
    {
      id: 0,
      preFix: 'TenantInfo',
      data: tenantInfoValidations,
    },
    {
      id: 1,
      preFix: 'AlternateInfo',
      data: alternateValidation,
    },
    {
      id: 2,
      preFix: 'OtherInfo',
      data: otherValidation,
    },
  ];
};
